import React from 'react'
import './MyComfirmMsgCss.css'
import Bubble from '../../Icons/Bubble'
import BgcClose from '../../Icons/BgcClose'
import intl from 'react-intl-universal'

export default function MyComfirmMsg (props) {
  const visible = props.visible === true ? props.visible : false // 是否显示modal
  const LeftIcon = props.LeftIcon || <Bubble height={24} width={24} /> // 左上角icon
  const rightIcon = props.rightIcon || <BgcClose height={24} width={24} /> // 右上角icon
  const messageVisable = props.mssageVisable || true
  const messageStyle = props.messageStyle || { fontSize: '1.1rem', fontFamily: 'YouYuan', fontWeight: '700', opacity: '0.7' }
  const info = props.info || intl.get('Are you sure you want to return these dishes?')
  const infoStyle = props.infoStyle || {} // 提示信息的样式
  const okButtonVisible = props.okButtonVisible || true // 是否显示确认按钮 默认为true
  const cancelButtonVisible = props.cancelButtonVisible || true // 是否显示取消按钮， 默认为true
  const onOkClick = props.onOkClick // 点击确定按钮的事件
  const onCloseClick = props.onCloseClick // 点击关闭按钮的事件
  const onCancelClick = props.onCancelClick // 点击取消按钮的事件
  const okButton = props.okButton || <div style={{ backgroundColor: '#3887fd', height: '2.2rem' }} className='w63 mb13 rds16 lh1-9 ffyy pt2' onClick={onOkClick}>{intl.get('OK')}</div> // 确定按钮组件
  const cancelButton = props.cancelButton || <div style={{ height: '2.2rem' }} className='cancelColor w63 mb13 mr29 lauto rds16 lh1-9 ffyy pt2 bd' onClick={onCancelClick}>{intl.get('Cancel')}</div>
  return (
    <div style={{ display: visible ? '' : 'none' }} className='w100 h100'>
      <div className='fixed bg5' style={{ top: '0', right: '0', bottom: '0', left: '0', opacity: '0.4', zIndex: '1' }} />{/* 遮罩层 */}
      <div className='w85 h23 fixed bgf auto rds10 bdc' style={{ zIndex: '2', top: '30%', left: '0', right: '0' }}>{/* 确认框提示信息 */}
        <div className='w100 pt7 pl18 pr18 h100 abs'>
          <ul className='flex h30'>{/* 确认框高度上三分之一 */}
            <li className='f1 tl'>
              {LeftIcon}
            </li>
            <li style={{ display: messageVisable ? '' : 'none' }} className='f8 fs19 '>
              <div className='pl10 pb3' style={messageStyle}>{intl.get('Tips')}</div>
            </li>
            <li className='f1 tr'>
              <span onClick={onCloseClick}>
                {rightIcon}
              </span>
            </li>
          </ul>
          <div className='pulse animated h39 fs18 fw1 pt5 pl3 ffyy ml23' style={infoStyle}>{info}</div>{/* 确认框高度中间三分之一，提示信息info */}
          <ul className='flex h30 gf fw1 tc ml23'>{/* 确认框高度下三分之一 */}
            <li style={{ display: okButtonVisible ? '' : 'none' }} className='f1'>
              {okButton}
            </li>
            <li style={{ display: cancelButtonVisible ? '' : 'none' }} className='f1'>
              {cancelButton}
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
